/**
 * 暗号化関連の定数
 */

/** マジックナンバー（8バイト）- ファイル形式識別子 */
export const MAGIC_NUMBER = 'PRECONV1';

/** IV（初期化ベクトル）のサイズ（バイト） */
export const IV_SIZE = 12;

/** AES-256の鍵サイズ（バイト） */
export const KEY_SIZE = 32;

/** ファイルヘッダーの合計サイズ（マジックナンバー + IV + 鍵） */
export const HEADER_SIZE = 8 + IV_SIZE + KEY_SIZE; // 52 bytes

/**
 * アプリ固有の秘密鍵（難読化用）
 * rawKeyとXOR演算することで、バイナリ解析時に鍵の特定を困難にする
 */
export const APP_SECRET_KEY = 'precon-supporter-2025-cfa-go-jp';
